import React from "react"

function LogoIcon(props) {
  const { className } = props || {}
  return (
    <svg
      className={`w-auto h-full ${className}`}
      viewBox="0 0 47 47"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M47 23.5C47 36.7995 36.4767 47 23.5 47C10.5234 47 0 36.7995 0 23.5C0 10.2005 10.5234 0 23.5 0C36.4767 0 47 10.2005 47 23.5ZM10.375 23.5033C10.375 31.5733 16.1854 36.9318 23.5453 36.9318C30.9052 36.9318 36.7157 31.5733 36.7157 23.5033C36.7157 15.4332 30.9052 10.0747 23.5453 10.0747C16.1854 10.0747 10.375 15.4332 10.375 23.5033Z"
        fill="url(#paint0_linear_850_1146)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24.1649 30.8929L18.3113 25.082C17.5036 24.2838 16.9844 23.1293 16.9844 21.829C16.9844 19.4171 18.7382 17.4644 20.8958 17.4644C22.265 17.4644 23.4649 18.2497 24.1649 19.4385C24.8649 18.2497 26.0649 17.4644 27.4341 17.4644C29.5955 17.4644 31.3455 19.4171 31.3455 21.829C31.3455 23.1293 30.8263 24.2838 30.0186 25.082L24.1649 30.8929Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id="paint0_linear_850_1146"
          x1="0"
          y1="47"
          x2="47"
          y2="47"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FF4C" />
          <stop offset="1" stopColor="#1DA1F2" />
        </linearGradient>
      </defs>
    </svg>
  )
}

export default LogoIcon
